<template>
  <div class="global-footer-copy-right-block">
    <p class="global-footer-copy-right">copyright©istyle,inc.</p>
  </div>
</template>

<script>
export default {
  name: 'copyright',
};
</script>
